import React from 'react';

const featureCardStyle = {
  padding: '1rem',
  border: '1px solid var(--border-color, #ddd)',
  borderRadius: '8px',
  marginBottom: '1rem',
};

const badgeStyle = {
  display: 'inline-block',
  fontSize: '0.7rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  padding: '2px 8px',
  borderRadius: '999px',
  marginLeft: '0.5rem',
  verticalAlign: 'middle',
};

const shippedBadge = {
  ...badgeStyle,
  backgroundColor: 'var(--success-color, #28a745)',
  color: '#fff',
};
const inProgressBadge = {
  ...badgeStyle,
  backgroundColor: 'var(--primary-color, #636cff)',
  color: '#fff',
};
const plannedBadge = {
  ...badgeStyle,
  backgroundColor: 'var(--text-secondary, #888)',
  color: '#fff',
};

const UpcomingFeaturesContent = ({ onNavigateToContact }) => {
  return (
    <div style={{ marginTop: "1rem", lineHeight: "1.5", fontSize: "0.9rem" }}>
      <p>
        We ship constantly. Here's what recently landed, followed by what's
        coming next — ordered by how close each feature is to release.
      </p>

      <h4 style={{ margin: '1.25rem 0 0.5rem' }}>Recently shipped</h4>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Custom Workflows
          <span style={shippedBadge}>Live</span>
        </h4>
        <p style={{ margin: 0 }}>
          A visual builder for multi-step agent pipelines: drag input, agent,
          tool, and logic nodes onto a canvas and connect them. Run them right
          from the chat panel and watch live, per-agent progress as each node
          works. Start from a built-in template or save your own.
        </p>
      </div>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Bring Your Own Endpoints &amp; Local Models
          <span style={shippedBadge}>Live</span>
        </h4>
        <p style={{ margin: 0 }}>
          Connect your own keys for Anthropic, Google, OpenAI, Azure, and
          AWS — or run agents on local models (Ollama / Stackform
          Connect) for maximum privacy and cost control. Store multiple
          configurations per provider and pick the exact model per agent.
        </p>
      </div>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Per-Agent Model Configuration
          <span style={shippedBadge}>Live</span>
        </h4>
        <p style={{ margin: 0 }}>
          Set your main model once, assign a different model and persona to each
          agent, and optionally choose a dedicated summarizer model for
          synthesis and reports — all under User Settings → Model Defaults.
        </p>
      </div>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Model Profiles
          <span style={shippedBadge}>Live</span>
        </h4>
        <p style={{ margin: 0 }}>
          Save your whole model setup as named profiles — for example a fast
          cloud profile and an all-local "Private" one — each with its own main
          model, summarizer, and per-agent assignments, then switch the active
          profile in a click from the chat panel's model selector. Create,
          duplicate, rename, and delete profiles under User Settings → Model
          Defaults, and pin a specific profile to a workflow so its runs always
          use the same preset.
        </p>
      </div>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Specialist Agents
          <span style={shippedBadge}>Live</span>
        </h4>
        <p style={{ margin: 0 }}>
          Dedicated Evaluator (metric-focused critique) and Challenger
          (adversarial stress-testing) agents join the generalist and research
          agents — usable in Ask, Swarm debates, and as workflow nodes.
        </p>
      </div>

      <h4 style={{ margin: '1.5rem 0 0.5rem' }}>Coming next</h4>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Interactive Mode
          <span style={inProgressBadge}>In Progress</span>
        </h4>
        <p style={{ margin: 0 }}>
          Edit any section of a response inline, regenerate just that paragraph,
          or copy individual blocks — without starting a new conversation.
          Great for iterative drafting and report building.
        </p>
      </div>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          Coding Workflow &amp; Agent
          <span style={plannedBadge}>Planned</span>
        </h4>
        <p style={{ margin: 0 }}>
          A dedicated coding pipeline with agents that can write, review, and
          reason about code, plus deeper document-centric workflows.
        </p>
      </div>

      <div style={featureCardStyle}>
        <h4 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
          More Specialist Agents
          <span style={plannedBadge}>Planned</span>
        </h4>
        <p style={{ margin: 0 }}>
          New domain specialists on the roadmap — including a data-analysis
          agent and a fact-checking agent with citation verification.
        </p>
      </div>

      <p style={{ marginTop: "1.5rem" }}>
        Have a feature request or want to be notified when something ships?{" "}
        <button
          onClick={onNavigateToContact}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            color: "var(--link-color, #007bff)",
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "inherit",
            fontFamily: "inherit",
          }}
        >
          Send us a message
        </button>{" "}
        — we read and respond to every one.
      </p>
    </div>
  );
};

export default UpcomingFeaturesContent;
